import { Alert, AlertTitle, Box, Grid, TextField } from '@mui/material'
import { useMemo } from 'react'
import { DynamicFormHandlerProps } from '..'
import { Controller, useFormContext } from 'react-hook-form';

export default function DynInserirNumeroMatricula({ spec, extras }: DynAguardandoPagamentoJoiaProps) {
    const { control } = useFormContext();

    const isTituloPago = useMemo(() => extras.titulo_pago !== undefined && extras.titulo_pago === true, [extras])

    return (
        <Box sx={{ width: '100%', mb: 2 }}>
            {isTituloPago ? (
                <Grid container size={{ xs: 12 }} spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <Controller
                            name={`${spec.name}.matricula`}
                            control={control}
                            rules={{ required: "Campo obrigatório",
                                validate: value => {
                                    if (!/^[0-9]+$/.test(String(value))) return "Deve ser um inteiro positivo sem vírgulas ou pontos";
                                    if (Number(value) <= 0) return "O valor deve ser maior que zero";
                                    return true;
                                }
                             }}
                            render={({ field, fieldState: { error, invalid } }) => {
                                return (
                                    <TextField
                                        {...field}
                                        required
                                        type='number'
                                        error={invalid}
                                        label="Matrícula"
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => field.onChange(e.target.value)}
                                        slotProps={{ htmlInput: { maxLength: 40 } }}
                                        helperText={error ? error.message : ""}
                                    />
                                );
                            }}
                        />
                    </Grid>
                </Grid>
            ) : (
                <Alert severity="info">
                    <AlertTitle>Aguardando Pagamento</AlertTitle>
                    O pagamento da sua joia ainda não foi confirmado. Por favor, verifique a tarefa anterior e certifique-se de que o pagamento foi realizado corretamente antes de tentar novamente.
                </Alert>
            )}
        </Box>
    )
}

interface DynAguardandoPagamentoJoiaProps extends DynamicFormHandlerProps {
}